import type { GetServerSideProps } from 'next';
import type { CategoryPageProps } from 'lib/queries/blog';
import React from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { Wrap } from '@leafwell/components';
import Archive from 'components/archive';
import CategoriesNavbar from 'components/categories-navbar';
import Loader from 'components/loader';
import PageWrap from 'components/page-wrap';
import { getCategoryPage } from 'lib/queries/blog';

const NewsletterForm = dynamic(() => import('components/newsletter-form'), {
  ssr: false,
  loading: () => {
    //to prevent layout shift
    return (
      <Wrap
        id="newsletter-signup"
        size="large"
        className="h-[494px] sm:h-[512px] md:h-[330px] lg:h-[272px]"
      />
    );
  },
});

export const getServerSideProps = (async context => {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59',
  );

  return await getCategoryPage(context);
}) satisfies GetServerSideProps<CategoryPageProps>;

export default function CategoryPage(props: CategoryPageProps) {
  const { isFallback } = useRouter();

  if (isFallback) {
    return <Loader />;
  }

  const {
    page: { name, seo },
    postsList: { posts, pagination },
    categories,
  } = props;

  return (
    <PageWrap seo={seo} title={name} pageType="blog-category">
      <CategoriesNavbar categories={categories} displayH1 />
      <Archive posts={posts} pagination={pagination} />
      <NewsletterForm />
    </PageWrap>
  );
}
